import React from "react"
import styled from "styled-components"
import devices from "styles/devices"
import Typography from "components/_blueprint/Typography/Typography"
import Guitar from "url:assets/images/illustrations/Guitar.png"

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  @media screen and ${devices.bp_lg} {
    width: 610px;
    flex: unset;
  }
`

const GuitarIllustration = styled.div`
  display: none;

  @media screen and ${devices.bp_lg} {
    display: block;
    width: 375px;
    height: 337px;
    background-image: url(${Guitar});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    flex-shrink: 0;
    position: absolute;
    right: 0;
    z-index: 1;
  }
`

export const OfferAcceptedHeader: React.FC = () => {
  return (
    <>
      <HeaderContent>
        <Typography.H1>Congratulations!</Typography.H1>
        <Typography.H1>Let's lock in your mortgage.</Typography.H1>
        <Typography.LargeBody color="secondary" margin="0">
          Your recommendation call is booked - the final step before we submit an application.
        </Typography.LargeBody>
      </HeaderContent>
      <GuitarIllustration />
    </>
  )
}
